module.exports = __webpack_public_path__ + "static/media/certificate.2791dcd0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/ssp2/certificate.svg
// module id = 493
// module chunks = 0